'use strict';

const { h } = require('phy');

const HeroTitle = require('../../coupons/views/hero-title');
const MainMenu = require('../../header/views/main-menu');
const AlertBar = require('../../../components/alert_bar');

function getHeaderElements({
  showTitleOntouch,
  isTouch,
  resourceKey,
  params,
  titleText,
  tag,
  searchCredentials,
  merchants,
  activePage,
  routes,
  blogUrl,
  themedPage,
  showTopOffers,
  alertAdvert,
}) {
  const heroTitle = HeroTitle({ resourceKey, params, titleText, tag });
  const mainMenu = h(MainMenu, {
    searchCredentials,
    merchants,
    activePage,
    routes,
    isTouch,
    blogUrl,
    themedPage,
    showTopOffers,
  });
  const alertBar = h(AlertBar, { advert: alertAdvert });

  const elements = [mainMenu];

  if ((isTouch && showTitleOntouch) || !isTouch) {
    elements.push(heroTitle);
  }

  elements.push(alertBar);

  return elements;
}

function Header(
  {
    showTitleOntouch = true,
    resourceKey,
    params,
    titleText,
    tag,
    merchants,
    activePage,
    routes,
  },
  context
) {
  const {
    blogUrl,
    isTouch,
    alertAdvert,
    themedPage,
    showTopOffers,
    searchCredentials,
  } = context;

  return h(
    'section',
    getHeaderElements({
      showTitleOntouch,
      isTouch,
      resourceKey,
      params,
      titleText,
      tag,
      searchCredentials,
      merchants,
      activePage,
      routes,
      blogUrl,
      themedPage,
      showTopOffers,
      alertAdvert,
    })
  );
}

module.exports = Header;
